export function useScrollToComment() {
  const scrollToComment = (commentId: string, isDesktop = true) => {
    const anchor = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (!anchor) {
      return;
    }

    anchor.scrollIntoView({
      behavior: 'smooth',
      block: isDesktop ? 'center' : 'start',
    });
  };

  return {
    scrollToComment,
  };
}
